/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {

	/**
	 * Process multiple event handlers in sequence even if handler is a Promise
	 * @param {...Function} handlers Event handlers to call in sequence
	 * @returns {Function}
	 */
	Vue.prototype.handleMultiple = async function(...handlers) {
		for (const handler of handlers) {
			let handlerResultOrPromise;
			if (typeof handler === 'function') {
				handlerResultOrPromise = handler.call(this);
			}
			if (typeof handlerResultOrPromise?.then === 'function') {
				await handlerResultOrPromise;
			}
		}
	};
	Vue.prototype.hm = Vue.prototype.handleMultiple;

};

export default {
	install
};
